import { CartesianGrid, Legend, Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { ChartsProps } from '../../interfaces/Indicator';
import useDataKey from '../../hooks/useDataKey';
import { forwardRef, useCallback } from 'react';
import CustomToolTip from './CustomToolTip';
import { INDICATOR_TYPE_PROCESS, messages } from '../../utils/const';
import NotDataDisplay from '../Cards/NotDataDisplay';
import { filterDataKeyByAnalysisVariables } from '../../views/IndicatorDisplay/utils/helpers';
import { useChartDomains } from '../../hooks/useChartDomains';


const LineCharts = forwardRef<HTMLDivElement, ChartsProps>(({ data, typeOfIndicador, variable_analisis, range, errorsNoData, filters, tooltip_indicadores_proc }, ref) => {
    const { domainYLeft } = useChartDomains(
        data,
        variable_analisis,
        null,
        range!,
        null
    );

    const { dataKey } = useDataKey(data, filters);

    const filteredDataKey = filterDataKeyByAnalysisVariables(
        dataKey ?? [],
        typeOfIndicador,
        variable_analisis
    );

    const tooltipContent = useCallback((props: any) => (
        <CustomToolTip
            {...props}
            isIndicatorTypeProc={typeOfIndicador === INDICATOR_TYPE_PROCESS}
            selectedKeys={tooltip_indicadores_proc ?? []}
        />
    ), [typeOfIndicador, tooltip_indicadores_proc]);

    const shouldShowTooltip = typeOfIndicador !== INDICATOR_TYPE_PROCESS || (tooltip_indicadores_proc ?? []).length > 0;

    return (
        <>
            <ResponsiveContainer width="100%" height="100%" ref={ref}>
                <LineChart
                    data={data}
                    margin={{
                        top: 10,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        dataKey="name"
                        stroke="#555C62"
                        tick={{ fontSize: 14 }}
                    />
                    <YAxis
                        domain={domainYLeft}
                        ticks={range?.ticks ?? undefined}
                        stroke="#555C62"
                        tick={{ fontSize: 14 }}
                        allowDecimals={false}
                        interval={0}
                    />
                    <Tooltip
                        content={shouldShowTooltip ? tooltipContent : undefined}
                        active={shouldShowTooltip ? undefined : false}
                        wrapperStyle={{ pointerEvents: 'auto', zIndex: 50 }}
                        isAnimationActive={false}
                    />
                    <Legend
                        wrapperStyle={{ fontSize: '0.875rem' }}
                        align='center'
                    />
                    <ReferenceLine y={0} stroke="#555C62" strokeWidth="2" />
                    {filteredDataKey?.map((key, index) => (
                        <Line
                            key={index}
                            name={key.key.split('-').map(entity => entity.split(':')[1]).join('/') ?? '-'}
                            type="monotone"
                            dataKey={key.key}
                            stroke={key.color}
                            strokeWidth={2}
                            isAnimationActive={false}
                        />
                    ))}
                </LineChart>
            </ResponsiveContainer>
            {errorsNoData ? <NotDataDisplay message={messages.chart} /> : null}
        </>
    );
});

export default LineCharts;